import React from "react";
import { Link, useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();

  return (
    <>
      <div className="">
        <div className="relative">
          <div className="max-w-[1320px] mx-auto  flex justify-around xl:justify-between mt-16 flex-wrap  absolute md:top-0 xl:top-0 right-0 left-0">
            <>
              <div className="text-center m-4  max-w-[220px] min-w-[220px] mx-auto flex-grow">
                <h2 className="text-[#1b0c3e] font-bold text-lg opacity-80 mb-3">
                  Video Husky
                </h2>
                <Link to="/reviews">
                  <h2 className="text-lg  my-3 text-[#4f4f4f] opacity-80 hover:opacity-100 cursor-pointer mb-1">
                    Customer Success Stories
                  </h2>
                </Link>
                <Link to="/pricing">
                  <h2 className="text-lg  my-3 text-[#4f4f4f] opacity-80 hover:opacity-100 cursor-pointer mb-1">
                    Pricing{" "}
                  </h2>
                </Link>

                <h2
                  onClick={() => navigate("/about")}
                  className="text-lg  my-3 text-[#4f4f4f] opacity-80 hover:opacity-100 cursor-pointer mb-1"
                >
                  About
                </h2>

                <Link to="/reviews">
                  <h2 className="text-lg   my-3  text-[#4f4f4f] opacity-80 hover:opacity-100 cursor-pointer mb-1">
                    Reviews
                  </h2>
                </Link>
              </div>
              <div className="text-center m-4  max-w-[200px] mx-auto flex-grow min-w-[220px]">
                <h2 className="text-[#1b0c3e] font-bold text-lg  opacity-80 mb-3">
                  {`Who it's for`}
                </h2>
                <Link to="/content-creators">
                  <h2 className="text-lg  my-3 text-[#4f4f4f] opacity-80 hover:opacity-100 cursor-pointer mb-1">
                    Content creators
                  </h2>
                </Link>
              </div>
              <div className="text-center m-4 mx-auto flex-grow max-w-[200px] min-w-[220px]">
                <h2 className="text-[#1b0c3e] font-bold text-lg  opacity-80 mb-3">
                  Support
                </h2>
                <Link to="/how-it-works">
                  <h2 className="text-lg  my-3 text-[#4f4f4f] opacity-80 hover:opacity-100 cursor-pointer mb-1">
                    How it works
                  </h2>
                </Link>
                <Link to="/FAQs">
                  <h2 className="text-lg  my-3 text-[#4f4f4f] opacity-80 hover:opacity-100 cursor-pointer mb-1">
                    FAQs
                  </h2>
                </Link>
                <h2
                  onClick={() => navigate("/contact-us")}
                  className="text-lg  my-3 text-[#4f4f4f] opacity-80 hover:opacity-100 cursor-pointer mb-1"
                >
                  Contact
                </h2>
              </div>

              {/* <div className="text-center m-4 min-w-[220px]  max-w-[200px] mx-auto flex-grow ">
                <h2 className="text-[#1b0c3e] font-bold text-lg  opacity-80 mb-3">
                  Useful links
                </h2>
                <h2
                  onClick={() => navigate("/video-craft-show")}
                  className="text-lg  my-3 text-[#4f4f4f] opacity-80 hover:opacity-100 cursor-pointer mb-1"
                >
                  The Videocraft Show
                </h2>

                <h2
                  onClick={() => navigate("/privacyPolicy")}
                  className="text-lg  my-3 text-[#4f4f4f] opacity-80 hover:opacity-100 cursor-pointer mb-1"
                >
                  Privacy
                </h2>
                <h2
                  onClick={() => navigate("/terms&conditions")}
                  className="text-lg  my-3 text-[#4f4f4f] opacity-80 hover:opacity-100 cursor-pointer mb-1"
                >
                  Terms & conditions
                </h2>
                <h2 className="text-lg  my-3 text-[#4f4f4f] opacity-80 hover:opacity-100 cursor-pointer mb-1">
                  Referral Programm
                </h2>
              </div> */}
            </>
            <div className="max-w-[800px]  z-10  mt-4 mx-auto flex items-center justify-center xl:hidden  sm:min-w-[640px] sm:px-0 px-4">
              <p className="mt-4 text-sm font-semibold  text-[#4f4f4f] opacity-50 mx-auto  text-center lg:text-left">
                COPYRIGHT 2022 © ALL RIGHTS RESERVED. VIDEO HUSKY LLC
              </p>
            </div>
          </div>
          <div className="max-w-[800px] mt-4 mx-auto xl:flex items-center justify-center hidden xl:absolute bottom-0 xl:bottom-64 right-0 left-0">
            <p className="mt-4 text-sm font-semibold  text-[#4f4f4f] opacity-80 mx-auto  text-center lg:text-left">
              COPYRIGHT 2022 © ALL RIGHTS RESERVED. VIDEO HUSKY LLC
            </p>
          </div>
          <img
            src={require("../images/footerImg2.png")}
            alt=""
            className="w-[100vw] hidden xl:block  h-[100%]"
          />
        </div>
      </div>
    </>
  );
};

export default Footer;
